import { render, staticRenderFns } from "./StringArrayField.vue?vue&type=template&id=4016a810"
import script from "./StringArrayField.vue?vue&type=script&lang=ts"
export * from "./StringArrayField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports